import { Chip, styled, type SxProps, type Theme } from '@mui/material';
import { toggleButtonBaseSx } from 'src/pages/Settings/memberships/styles';

export const SyncedChip = styled(Chip)(({ theme }) => ({
  height: theme.typography.pxToRem(20),
  fontSize: theme.typography.pxToRem(11),
  fontWeight: 500,
  backgroundColor: theme.palette.action.selected,
}));

export const blockTypeIconSx: SxProps<Theme> = {
  color: 'text.secondary',
  fontSize: '1.125rem',
  flexShrink: 0,
};

export const blockListIntroSx: SxProps<Theme> = {
  px: 2,
  pt: 2,
  pb: 1,
};

export const addBlockButtonSx: SxProps<Theme> = {
  alignSelf: 'stretch',
  mx: 2,
  mt: 1.5,
  mb: 2,
  textTransform: 'none',
  fontWeight: 500,
  borderStyle: 'dashed',
};

export const removeBlockButtonSx: SxProps<Theme> = {
  alignSelf: 'flex-start',
  textTransform: 'none',
  fontWeight: 500,
  mt: 1,
};

export const segmentedToggleSx: SxProps<Theme> = {
  ...toggleButtonBaseSx,
  py: 0.75,
  flex: 1,
  gap: 0.75,
  '&.Mui-selected::before': {
    content: '"\\2022"',
    fontSize: '0.6em',
    lineHeight: 1,
  },
};
